import * as React from "react";
import {
  InvoiceItemSetting,
  InvoiceItemValidator,
} from "@graffer-inc/cloud-gov-core";

export const useEditModal = (initItem?: InvoiceItemSetting) => {
  const [item, setItem] = React.useState<InvoiceItemSetting>(
    initItem ?? {
      formulaId: "",
      description: "",
      taxRate: "0",
    },
  );
  const [touched, setTouched] = React.useState<{
    [key in keyof InvoiceItemSetting]: boolean;
  }>(
    initItem
      ? {
          description: true,
          formulaId: true,
          taxRate: true,
        }
      : {
          description: false,
          formulaId: false,
          taxRate: false,
        },
  );
  const [error, setError] = React.useState<{
    [key in keyof InvoiceItemSetting]?: string;
  }>({});

  React.useEffect(
    () => setError(new InvoiceItemValidator(item).validate()),
    [item, setError],
  );
  return {
    touched,
    setTouched,
    item,
    setItem,
    error,
  };
};
